'use client';

import { AD_PLACEMENTS } from '../adPlacements';
import { NativeAdSlot } from '../NativeAdSlot';

interface DonationWelloPickAdProps {
  className?: string;
}

export const DonationWelloPickAd = ({
  className,
}: DonationWelloPickAdProps) => (
  <NativeAdSlot {...AD_PLACEMENTS.donationWelloPick} className={className} />
);
